export default {
  flock_app_store: 'App Store do Flock',
  get_more_apps: 'Baixar mais apps',
  app_store_button_label: 'Apps',
  directory_button_label: 'Diret\u00f3rio',
  roster_title: 'Canais e contatos',
};



// WEBPACK FOOTER //
// ./src/I18N/pt-br.js